import { render, staticRenderFns } from "./newSubContent.vue?vue&type=template&id=d3144ae6&scoped=true&"
import script from "./newSubContent.vue?vue&type=script&lang=js&"
export * from "./newSubContent.vue?vue&type=script&lang=js&"
import style0 from "./newSubContent.vue?vue&type=style&index=0&id=d3144ae6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3144ae6",
  null
  
)

export default component.exports